import {
  type ErrorType,
  useApiOrdersV1SalesOrdersDocumentsPreSignedUrlCreate,
  useApiOrdersV1SalesOrdersDocumentsUploadCreate,
} from 'api';

import { useUploadAndCreateDocument } from '~/document';

export const useUploadAndCreateSalesOrderDocument = () => {
  const { mutateAsync: createDocument } = useApiOrdersV1SalesOrdersDocumentsUploadCreate<ErrorType<Error>>();
  const { mutateAsync: generatePreSignedURL } =
    useApiOrdersV1SalesOrdersDocumentsPreSignedUrlCreate<ErrorType<Error>>();
  return useUploadAndCreateDocument<{ slug: string }>(generatePreSignedURL, createDocument);
};
